import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './language.const';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly languageStorageKey = 'lang';

  private readonly currentLanguage$: BehaviorSubject<string> =
    new BehaviorSubject(DEFAULT_LANGUAGE);

  private readonly doc = inject(DOCUMENT);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly translateService = inject(TranslateService);

  public initCurrentLanguage(): void {
    const currentLanguage = this.normalizeLanguage(
      this.localStorageService.get(this.languageStorageKey),
    );

    if (currentLanguage !== DEFAULT_LANGUAGE) {
      this.setCurrentLanguage(currentLanguage);
    }

    this.currentLanguage$.subscribe((language: string) => {
      this.localStorageService.set(this.languageStorageKey, language);
      this.translateService.use(language);
      this.doc.documentElement.setAttribute('lang', language);
    });
  }

  public getCurentLanguage(): string {
    return this.currentLanguage$.value;
  }

  public getCurentLanguageObservable(): Observable<string> {
    return this.currentLanguage$.asObservable();
  }

  public setCurrentLanguage(name: string): void {
    this.currentLanguage$.next(this.normalizeLanguage(name));
  }

  private normalizeLanguage(language: string | null | undefined): string {
    if (typeof language !== 'string') {
      return DEFAULT_LANGUAGE;
    }

    return SUPPORTED_LANGUAGES.has(language) ? language : DEFAULT_LANGUAGE;
  }
}
